import { CoordinatesModel, Log } from '@core';
import { combineLatest, Observable, of, switchMap, take, tap } from 'rxjs';
import { StartupState } from '../startup.state';
import { inject } from '@angular/core';
import { StartupStep } from '../startup-step';
import { FeatureFlag, FeatureFlagHandler } from '@feature-flags';
import { UpdateUserLocationCommandHandler } from '../../../../projects/profile/src/lib/application/handlers';
import { UpdateAlertsLocationCommandHandler } from '@notifications';

export class UpdateUserLocationStep extends StartupStep {
  private readonly featureFlagHandler: FeatureFlagHandler = inject(FeatureFlagHandler);
  private readonly updateUserLocationCommandHandler: UpdateUserLocationCommandHandler = inject(
    UpdateUserLocationCommandHandler
  );
  private readonly updateAlertsLocationCommandHandler: UpdateAlertsLocationCommandHandler = inject(
    UpdateAlertsLocationCommandHandler
  );

  executeStep(state: StartupState): Observable<StartupState> {
    this.logger.log(Log.Startup, { message: 'UpdateUserLocationStep START' });

    if (!state.coordinates$) {
      this.logger.log(Log.Startup, { message: 'UpdateUserLocationStep SKIPPED - no coordinates$ in state' });
      return of(state);
    }

    combineLatest([state.coordinates$, this.featureFlagHandler.isEnabled$(FeatureFlag.UPDATE_USER_LOCATION)])
      .pipe(
        take(1),
        switchMap(([coordinates, useNewFlow]: [CoordinatesModel | null, boolean]) =>
          useNewFlow
            ? this.updateUserLocationCommandHandler.updateLocation(coordinates)
            : this.updateAlertsLocationCommandHandler.setLocation(coordinates)
        ),
        tap(() => this.logger.log(Log.Startup, { message: 'UpdateUserLocationStep COMPLETED' }))
      )
      .subscribe();

    return of(state);
  }
}
